import React, { useState, useRef } from 'react';
import { Link } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaTelegram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { IoMdShare } from "react-icons/io";
import { BsTwitterX } from "react-icons/bs";

function ShareComponent({index, url}) {
  const [hoveredIndex, setHoveredIndex] = useState(-1);
  const timeoutRef = useRef(null);

  const handleMouseEnter = (index) => {
    clearTimeout(timeoutRef.current);
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    // Delay the mouse leave action by 500 milliseconds
    timeoutRef.current = setTimeout(() => {
      setHoveredIndex(-1);
    }, 1000);
  };

  const handleShareMouseEnter = (index) => {
    clearTimeout(timeoutRef.current);
    setHoveredIndex(index);
  };

  const handleShareMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setHoveredIndex(-1);
    }, 1000);
  };
  return (
    <>
      <div className='d-flex flex-column align-items-end justify-content-end'>
        <Link to="#" onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={handleMouseLeave} className='list-group-item p-2 px-4 d-flex justify-content-center align-items-center border border-0 rounded-1 shadow-lg bg-body rounded border-secondary bg-light'><IoMdShare className='me-1'/> Share</Link>
        {hoveredIndex === index &&
          <div className='Share-background' onMouseEnter={() => handleShareMouseEnter(index)} onMouseLeave={handleShareMouseLeave}>
            <div className='share-item card p-2 px-3'>
              <Link to={`https://facebook.com/share_channel/?link=https://insight.examinares.com/blog/${url}&app_id=966242223397117&source_surface=external_reshare&display&hashtag`} className='list-group-item py-1 share-item-link'><FaFacebook className='me-1'/> Facebook</Link>
              <Link to={`https://twitter.com/intent/tweet?url=https://insight.examinares.com/blog/${url}`} className='list-group-item py-1 share-item-link'><BsTwitterX className='me-1'/> Twitter</Link>
              {/* <Link to={`https://instagram.com/share/url?url=https://insight.examinares.com/blog/${url}`} className='list-group-item py-1 share-item-link'><FaInstagram className='me-1'/> Instagram</Link> */}
              <Link to={`https://t.me/share/url=https://insight.examinares.com/blog/${url}`} className='list-group-item py-1 share-item-link'><FaTelegram className='me-1'/>Telegram</Link>
              <Link to={`https://api.whatsapp.com/send?text=https://insight.examinares.com/blog/${url}`} className='list-group-item py-1 share-item-link'><FaWhatsapp className='me-1'/>WhatsApp</Link>
            </div>
          </div>}
      </div>
    </>
  )
}

export default ShareComponent
